import { useEffect, useState } from 'react';
import { QueryClient } from '@tanstack/react-query';

export const useAuth = () => {
  const [isAuthenticated, setIsAuthenticated] = useState<boolean>(false);

  useEffect(() => {
    // Check for token in localStorage
    const token = localStorage.getItem('accessToken');
    setIsAuthenticated(!!token);
  }, []);

  const login = (token: string) => {
    localStorage.setItem('accessToken', token);
    setIsAuthenticated(true);
  };

  const logout = (queryClient?: QueryClient) => {
    // Повністю очищуємо localStorage замість видалення лише accessToken
    localStorage.clear();
    setIsAuthenticated(false);

    // Clear React Query cache if queryClient is provided
    if (queryClient) {
      queryClient.clear();
    }

    // Перенаправляємо на сторінку логіну
    window.location.href = '/auth/login';
  };

  return {
    isAuthenticated,
    login,
    logout,
  };
}; 